var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0834 7.52148C10.0834 7.01522 10.4938 6.60482 11 6.60482C11.5063 6.60482 11.9167 7.01522 11.9167 7.52148C11.9167 8.02775 11.5063 8.43815 11 8.43815C10.4938 8.43815 10.0834 8.02775 10.0834 7.52148ZM10.0834 11.1882C10.0834 10.6819 10.4938 10.2715 11 10.2715C11.5063 10.2715 11.9167 10.6819 11.9167 11.1882V14.8548C11.9167 15.3611 11.5063 15.7715 11 15.7715C10.4938 15.7715 10.0834 15.3611 10.0834 14.8548V11.1882ZM11 2.02148C5.94004 2.02148 1.83337 6.12815 1.83337 11.1882C1.83337 16.2482 5.94004 20.3548 11 20.3548C16.06 20.3548 20.1667 16.2482 20.1667 11.1882C20.1667 6.12815 16.06 2.02148 11 2.02148ZM11 18.5215C6.95754 18.5215 3.66671 15.2307 3.66671 11.1882C3.66671 7.14565 6.95754 3.85482 11 3.85482C15.0425 3.85482 18.3334 7.14565 18.3334 11.1882C18.3334 15.2307 15.0425 18.5215 11 18.5215Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedInfoIcon);
export default __webpack_public_path__ + "static/media/DeprecatedInfoIcon.3ef41d4322d41c2b765b44d88b177dd6.svg";
export { ForwardRef as ReactComponent };